<template>
  <mobile-view>
    <h4 class="text-center" v-text="$t('dashboard.allEescorts')" />
    <v-toolbar flat class="d-flex justify-space-around">
      <v-btn text :small="$vuetify.breakpoint.xsOnly" color="primary" @click="setToday">{{ $t("date.today") }}</v-btn>
      <v-btn fab :x-small="$vuetify.breakpoint.xsOnly" text color="grey darken-2" @click="prev">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <span v-if="$refs.calendar" class="mx-2 text-sm-h6 subtitle-1" v-text="monthString()" />
      <v-btn fab :x-small="$vuetify.breakpoint.xsOnly" text color="grey darken-2" @click="next">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn fab :small="$vuetify.breakpoint.xsOnly" text color="primary" @click="loadData">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn fab :small="$vuetify.breakpoint.xsOnly" text color="green" @click="toggleCalendarType">
        <v-icon>mdi-calendar-edit</v-icon>
      </v-btn>
      <color-filter v-model="colorsFilter" />
    </v-toolbar>
    <v-sheet height="82vh" :dir="$i18n.locale === 'he' ? 'rtl' : 'ltr'">
      <v-calendar ref="calendar" v-model="today" color="primary" :events="filteredEvents" :categories="colorsItems"
        category-text="text" category-show-all :event-category="({ color }) => $t(`colors.${color}`)"
        :type="calendarType" event-overlap-mode="column" :interval-height="70" event-overlap-threshold="10"
        :event-color="({ isDone, color }) => isDone ? '#ffffff' : color"
        :event-text-color="({ isDone }) => isDone ? 'success' : '#ffffff'" @click:more="showEvent" @click:date="showEvent"
        @click:day="showEvent" @change="updateRange" @click:event="showEvent" />
    </v-sheet>
    <user-escort-display v-if="showDialog" v-model="showDialog" :escort="chosenEscort" :event="chosenEvent"
      :today="chosenEvent.start" />
    <user-escort-handler v-if="createEscortDialog" v-model="createEscortDialog" />
    <float-btn @cb="createEscortDialog = true" />
  </mobile-view>
</template>
<script>
import EventMixins from "@/mixins/events";
import listsMixins from "@/mixins/lists";
import times from "@/mixins/times";
import FloatBtn from "@/components/generics/FloatBtn";
import UserEscortDisplay from "@/components/UserEscortDisplay";
import MobileView from "@/layouts/MobileView";
import UserEscortHandler from "@/components/handlers/UserEscortHandler";
import ColorFilter from "@/components/generics/ColorFilter.vue";

export default {
  name: "AllEscorts",
  components: {
    FloatBtn,
    UserEscortDisplay,
    UserEscortHandler,
    MobileView,
    ColorFilter,
  },
  name: "calendar",
  mixins: [listsMixins, EventMixins, times],
  data: () => ({
    loading: false,
    addDialog: false,
    showDialog: false,
    chosenEscort: {},
    chosenEvent: {},
    createEscortDialog: false,
    calendarType: "day",
  }),
  computed: {
    escorts() {
      return this.$store.getters.escorts;
    },
  },
  watch: {
    escorts() {
      this.updateRange();
    },
  },
  methods: {
    createEvent() {
      this.chosen = null;
      this.addDialog = true;
    },
    showEvent({ event }) {
      if (!event) return;
      this.$store.commit("escort/set", event.escort);
      this.chosenEscort = event.escort;
      this.chosenEvent = event;
      this.showDialog = true;
    },
    async loadData() {
      await this.fetchEscortsInRange();
    },
    toggleCalendarType() {
      const CALENDAR_TYPES = ["day", "category", "4day"];
      const nextIndex =
        (CALENDAR_TYPES.indexOf(this.calendarType) + 1) % CALENDAR_TYPES.length;
      this.calendarType = CALENDAR_TYPES[nextIndex];
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>
